import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

export default function Education() {
  const { t } = useTranslation();

  const audiences = [
    {
      kicker: "Students",
      title: t("for_students"),
      items: [t("for_students_1"), t("for_students_2"), t("for_students_3"), t("for_students_4")],
    },
    {
      kicker: "Teachers",
      title: t("for_educators"),
      items: [t("for_educators_1"), t("for_educators_2"), t("for_educators_3"), t("for_educators_4")],
    },
    {
      kicker: "Schools",
      title: t("for_institutions"),
      items: [
        t("for_institutions_1"),
        t("for_institutions_2"),
        t("for_institutions_3"),
        t("for_institutions_4"),
      ],
    },
    {
      kicker: "Learn",
      title: t("learning_resources"),
      items: [
        t("learning_resources_1"),
        t("learning_resources_2"),
        t("learning_resources_3"),
        t("learning_resources_4"),
      ],
    },
  ];

  return (
    <MarketingLayout>
      <div className="marketing-page-content education-page education-page--wide">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Solutions</p>
          <h1>{t("education_title")}</h1>
          <p className="page-lead">{t("education_subtitle")}</p>
        </header>

        <section className="marketing-section-card education-hero">
          <span className="marketing-kicker" aria-hidden>Pricing</span>
          <h2 className="marketing-section-title">{t("education_pricing")}</h2>
          <p className="marketing-section-text mb-4">{t("education_pricing_desc")}</p>
          <p className="marketing-section-text education-discount">{t("education_discount")}</p>
        </section>

        <div className="education-grid">
          {audiences.map((block) => (
            <section key={block.title} className="marketing-section-card">
              <span className="marketing-kicker" aria-hidden>
                {block.kicker}
              </span>
              <h3 className="marketing-section-title">{block.title}</h3>
              <ul className="marketing-list">
                {block.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className="marketing-cta-row">
          <Link to="/Contact" className="marketing-cta">
            {t("apply_education")}
          </Link>
          <Link to="/pricing" className="marketing-cta marketing-cta--secondary">
            View plans
          </Link>
        </div>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
